import {getStatsigClient} from "../utils/statsig";

export const initContact = form => {
    $('button[name="contact"]').click(e => {
        let contact_btn = $(e.currentTarget);
        const textData = contact_btn.data("text");
        $("#id_teacher").val(contact_btn.data("id") || "");
        // prettier-ignore
        $("#modal-title-text").html(`${textData} <span id="teacher-name" class="highlight">${contact_btn.data("name") || ""}</span>`);
        $("body").addClass("fixed");
        form.toggleClass("hidden");
    });

    // Prevent Double Submits
    document
        .getElementById("contact_teacher_form")
        .addEventListener("submit", e => {
            const contactTeacherform = e.target;
            // Prevent if already submitting
            if (contactTeacherform.classList.contains("is-submitting")) {
                e.preventDefault();
            }

            // Add class to hook our visual indicator on
            contactTeacherform.classList.add("is-submitting");
        });
};

export const initModalClose = () => {
    $("#modal-title > .fa-times").click(() => {
        $("#contact-modal").toggleClass("hidden");
        $("body").removeClass("fixed");
    });
};
